export default {
  table_ordering: 'Zamawianie do stolika',
  table: 'Stolik',
  pickup_or_delivery: 'Odbiór lub dostawa',
  asap: 'Jak najszybciej',
  served_in: 'Podanie za {{time}} min',
  not_taking_orders: 'Zamówienia wstrzymane',
  not_your_table: 'To nie Twój stolik? Zeskanuj kod na swoim.',
  eating_here: {
    title: 'Jesz na miejscu?',
    back_to_table: 'Zamów do: {{table}}. Przyniesiemy Ci zamówienie.',
    scan_code: 'Zeskanuj kod QR na stoliku, aby zamówić do stolika.',
  },
  notes: {
    table_unavailable: {
      title: 'Kod QR tego stolika już nie działa.',
      text: 'Zapytaj obsługę. Nadal możesz zamówić z odbiorem osobistym.',
      text_no_pickup: 'Zapytaj obsługę.',
    },
    table_ordering_off: {
      title: 'Zamawianie do stolika jest teraz niedostępne.',
      text: 'Zamiast tego możesz zamówić z odbiorem osobistym.',
    },
    load_failed: {
      title: 'Nie udało się załadować Twojego stolika.',
      text: 'Zeskanuj kod QR ponownie.',
    },
    closed: {
      title: 'Jesteśmy teraz zamknięci.',
      text: 'Zamówienia do stolika możesz składać od {{time}}.',
      text_later: 'Zamówienia do stolika możesz składać, gdy tylko znów otworzymy.',
    },
    paused: {
      title: 'Nie przyjmujemy teraz zamówień.',
      text: 'Zapytaj obsługę lub spróbuj ponownie za kilka minut.',
    },
  },
  cart: {
    closed:
      'Teraz zamknięte. Zamówienia do stolika możesz składać od {{time}}. Koszyk zostanie zachowany do tego czasu.',
    closed_later: 'Teraz zamknięte. Koszyk zostanie zachowany do naszego ponownego otwarcia.',
    paused: 'Nie przyjmujemy teraz zamówień. Twój koszyk zostanie zachowany. Zapytaj obsługę.',
  },
  cash_note: 'Zapłać gotówką przy kasie.',
  confirmation: {
    bring_to_table: 'Przyniesiemy zamówienie do Twojego stolika.',
    your_table: 'Twój stolik',
    moved_table: 'Przeniesiono do innego stolika? Podaj obsłudze numer zamówienia <strong>{{number}}</strong>.',
  },
  served: 'Podano',
};
